export const customStyles = {
    table: {
        style: {
            minWidth: "100%",
            backgroundColor: "#fff",
        },
    },

    headRow: {
        style: {
            background:
                "linear-gradient(90deg, #7E00D1 0%, #9333EA 100%)",
            minHeight: "44px",
            height: "44px",
            borderBottomWidth: "0px",

            "@media (max-width: 1024px)": {
                minHeight: "42px",
                height: "42px",
            },

            "@media (max-width: 768px)": {
                minHeight: "40px",
                height: "40px",
            },

            "@media (max-width: 480px)": {
                minHeight: "38px",
                height: "38px",
            },
        },
    },

    headCells: {
        style: {
            color: "#fff",
            fontSize: "12px",
            fontWeight: "700",
            paddingTop: "6px",
            paddingBottom: "6px",
            paddingLeft: "10px",
            paddingRight: "10px",
            whiteSpace: "nowrap",
            textTransform: "capitalize",

            "@media (max-width: 1024px)": {
                fontSize: "11px",
                paddingLeft: "8px",
                paddingRight: "8px",
            },

            "@media (max-width: 768px)": {
                fontSize: "10px",
                paddingTop: "5px",
                paddingBottom: "5px",
                paddingLeft: "7px",
                paddingRight: "7px",
            },

            "@media (max-width: 480px)": {
                fontSize: "9px",
                paddingTop: "4px",
                paddingBottom: "4px",
                paddingLeft: "6px",
                paddingRight: "6px",
            },
        },
    },

    rows: {
        style: {
            minHeight: "58px",
            fontSize: "13px",
            borderBottom: "1px solid #f1f5f9",
            backgroundColor: "#fff",
            transition: "all 0.2s ease",

            "@media (max-width: 1024px)": {
                minHeight: "62px",
                fontSize: "12px",
            },

            "@media (max-width: 768px)": {
                minHeight: "58px",
                fontSize: "11px",
            },

            "@media (max-width: 480px)": {
                minHeight: "54px",
                fontSize: "10px",
            },
        },

        stripedStyle: {
            backgroundColor: "#fcfcfc",
        },

        highlightOnHoverStyle: {
            backgroundColor: "#f8f5ff",
            transitionDuration: "0.15s",
            transitionProperty: "background-color",
            outlineStyle: "none",
            cursor: "pointer",
        },
    },

    cells: {
        style: {
            paddingTop: "10px",
            paddingBottom: "10px",
            paddingLeft: "10px",
            paddingRight: "10px",
            fontSize: "13px",

            "@media (max-width: 1024px)": {
                fontSize: "12px",
                paddingLeft: "8px",
                paddingRight: "8px",
            },

            "@media (max-width: 768px)": {
                fontSize: "11px",
                paddingTop: "8px",
                paddingBottom: "8px",
                paddingLeft: "7px",
                paddingRight: "7px",
            },

            "@media (max-width: 480px)": {
                fontSize: "10px",
                paddingTop: "6px",
                paddingBottom: "6px",
                paddingLeft: "6px",
                paddingRight: "6px",
            },
        },
    },

    pagination: {
        style: {
            minHeight: "52px",
            borderTop: "1px solid #f1f5f9",
            fontSize: "13px",

            "@media (max-width: 768px)": {
                fontSize: "11px",
                minHeight: "48px",
            },

            "@media (max-width: 480px)": {
                fontSize: "10px",
                minHeight: "44px",
            },
        },
    },
};